import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import typographyStyle from "assets/jss/material-kit-react/views/componentsSections/typographyStyle.jsx";

class SectionBody extends React.Component {
  render() {
    const { classes, data } = this.props;
    const dataTitle = data.map(item => item.title);
    const dataSubtitle = data.map(item => item.subtitle);
    const dataBody = data.map(item => item.body);
    const style = {
      paddingBottom: "10px"
    }

    return (
      <div style={style} className={classes.section}>
        <div className={classes.container}>
          <div id="typography">
            <GridContainer>

              <GridItem xs={12} sm={12}>
                <div className={classes.title}>
                  <h1 className={classes.title}>{dataTitle}</h1>
                </div>
              </GridItem>

              <GridItem xs={12} sm={12}>
                <div>
                  <h2>{dataSubtitle}</h2>
                </div>
              </GridItem>

              <GridItem xs={12} sm={12}>
                <p>{dataBody}</p>
              </GridItem>

            </GridContainer>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(typographyStyle)(SectionBody);



// WEBPACK FOOTER //
// ./src/views/AboutUs/Sections/SectionBody.jsx